import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { SessionQuery } from '../core/state';
import { map, take, switchMap, of } from 'rxjs';
import { Models as GlobalModels } from '../models';

export const alreadyLoggedInGuard = () => {
  const router = inject(Router);
  const msalService = inject(MsalService);
  const sessionQuery = inject(SessionQuery);

  return msalService.initialize().pipe(
    map(() => msalService.instance.getAllAccounts().length > 0),
    switchMap((loggedIn) => {
      if (!loggedIn) {
        return of(true); // if not logged in, return true
      }
      // else return UrlTree
      return sessionQuery.getUserSettings().pipe(
        take(1),
        map((userSettings) => {
          // By default, all users with the dashboard enabled will be redirected to the ~/dashboard option,
          // even if they have not configured the launching page yet.
          if (!userSettings?.appLaunchSetting || userSettings?.appLaunchSetting === GlobalModels.AppLaunchSetting.Dashboard) {
            return router.createUrlTree(['/dashboard']);
          } else {
            return router.createUrlTree(['/pipeline']);
          }
        }),
      );
    }),
  );
};
